export default __webpack_public_path__ + "static/media/bd.e9ac60d9.svg";